module.exports = __webpack_public_path__ + "static/media/feature-manage2.86a55cd2.png";